export const getLocale = () => localStorage.getItem("i18nextLng");
export const setLocale = (locale: string) => {
    localStorage.setItem("i18nextLng", locale);
};
